
    import { defaultTitle } from "@/main"
    import { defineComponent } from "vue"

    export default defineComponent({
        components: {

        },
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {

        },

        created () {
            document.title = defaultTitle
        },

    })

    